const countries = [
    'Denmark', 'Sweden', 'Finland', 'Norway', 'Germany', 'Netherlands', 'Poland'
]

export const countriesStr = (lastSeperator) => {
    return `${countries.slice(0, countries.length - 1)
        .reduce((acc, cur) => `${acc}, ${cur}`)} ${lastSeperator} 
        ${countries[countries.length - 1]}` 
}